import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {GlobalService} from "../../../global.service";
import {EventsService} from "../../events.service";
import {ActivatedRoute, Router} from "@angular/router";
import {isPlatformBrowser} from "@angular/common";
import {FacebookService, InitParams} from "ngx-facebook";
import {NotificationsService} from "angular2-notifications";
import {Title} from "@angular/platform-browser";

declare const initsnow: any;

@Component({
  selector: 'app-winter-wonder',
  templateUrl: './winter-wonder.component.html',
  styleUrls: ['./winter-wonder.component.css']
})
export class WinterWonderComponent implements OnInit {
  mobileView: boolean = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private router: Router,
              private notify: NotificationsService, private fb: FacebookService,
              private activeRoute: ActivatedRoute, public eventService: EventsService,
              public globalService: GlobalService, private titleService:Title) {
    this.titleService.setTitle('Winter Wonder')
    if (globalService.isBrwoser) {
      if (window.screen.width < 768) {
        this.mobileView = true;
      }
    }

    if (isPlatformBrowser(this.platformId)) {
      let fbParams: InitParams = {
        appId: '1692568150989522',
        xfbml: true,
        version: 'v3.3'
      }
      this.fb.init(fbParams);
    }
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      initsnow();
    }
    if (this.router.url.split('/').length < 3)
      this.router.navigateByUrl('/winter-wonder/fortnite');
  }


}
